(function (Drupal, $) {
  Drupal.behaviors.denMapViewActions = {
    attach: function attach(context) {
      $('#views-exposed-form-den-by-denny-s-locations-block-2', context).each(function () {
        var searchWrapper = $('.js--exposed__form__search').parent('.js-form-item');
        if (!searchWrapper.hasClass('appended')) {
          searchWrapper.append('<div class="newsroom__styled-form__search__icon"><img src="themes/custom/meltdown/images/icon/24x24/search.svg" /></div>');
          searchWrapper.addClass('appended');
        }
        $('.js--den__map__location').on('click', function(){
          var latLonData = $(this).data('latlon');
          var latLonArr = latLonData.split(' ');
          $('.js--den__map__location').removeClass('clicked');
          $(this).addClass('clicked');
          $('.geofield-lat').val(latLonArr[1]);
          $('.geofield-lon').val(latLonArr[0]);
          $('[data-drupal-selector="views-exposed-form-den-by-denny-s-locations-block-1"] .form-submit').click();
        });
      });
    }
  }
})(Drupal, jQuery);
